import React from 'react';
import { FiChevronLeft } from 'react-icons/fi';
import { Link } from 'react-router-dom';

import IconLabel from 'components/atoms/IconLabel';

function BackNavigation() {
  // Corresponding with the <Link> in BackOfficeEnterpriseEditDrawer
  return (
    <Link relative="path" to="../..">
      <IconLabel icon={<FiChevronLeft size={22} />} label="Back to enterprise list" gap={4} />
    </Link>
  );
}

export default BackNavigation;
